import { RuntimeNodeBase } from './RuntimeNodeBase';

/**
 * 整数运算节点。
 *
 * 对左右输入执行加、减、乘、除、取模，并输出整数结果。
 */
export class IntOperationNode extends RuntimeNodeBase {
    /**
     * 输出整数运算结果端口。
     *
     * @returns 运算结果向下取整后的值。
     */
    public value(): number {
        return Math.floor(runOperation(
            String(this.node.data?.op ?? this.node.data?.operator ?? 'add'),
            this.inputNumber('left', 0),
            this.inputNumber('right', 0),
        ));
    }
}

/**
 * 浮点运算节点。
 *
 * 对左右输入执行加、减、乘、除、取模，并输出浮点结果。
 */
export class FloatOperationNode extends RuntimeNodeBase {
    /**
     * 输出浮点运算结果端口。
     *
     * @returns 运算后的浮点数。
     */
    public value(): number {
        return runOperation(
            String(this.node.data?.op ?? this.node.data?.operator ?? 'add'),
            this.inputNumber('left', 0),
            this.inputNumber('right', 0),
        );
    }
}

/**
 * 取整节点。
 *
 * 支持四舍五入、向上取整、向下取整。
 */
export class RoundNumberNode extends RuntimeNodeBase {
    /**
     * 输出取整结果端口。
     *
     * @returns 根据 mode 处理后的整数。
     */
    public value(): number {
        const value = this.inputNumber('value', 0);
        const mode = String(this.node.data?.mode ?? 'round');
        if (mode === 'ceil') return Math.ceil(value);
        if (mode === 'floor') return Math.floor(value);
        return Math.round(value);
    }
}

function runOperation(op: string, left: number, right: number): number {
    if (op === 'subtract' || op === 'sub') return left - right;
    if (op === 'multiply' || op === 'mul') return left * right;
    if (op === 'divide' || op === 'div') return right === 0 ? 0 : left / right;
    if (op === 'mod') return right === 0 ? 0 : left % right;
    if (op === 'min') return Math.min(left, right);
    if (op === 'max') return Math.max(left, right);
    return left + right;
}
